import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { AdMutationResult, AdRequest, AdsApiResponse } from './types';
import { ADS_QUERY_KEY } from './useGetAds';

type MutationParams = { adId: string; data: Omit<AdRequest, 'assigned_hotels'> };

/**
 * Edytuje kreację i uruchamia job, który przechodzi po wszystkich hotelach
 * z przypisaniem i nadpisuje tam dokument o tym samym id. Listy hoteli tu NIE
 * wysyłamy — backend bierze ją z bazy, żeby zapis ze starego formularza nie
 * cofnął przypisań zrobionych w międzyczasie (od tego jest `useAssignAdToHotels`).
 */
export const usePatchAd = (
  options?: UseMutationOptions<AdMutationResult, AxiosError, MutationParams>,
): UseMutationResult<AdMutationResult, AxiosError, MutationParams> => {
  const queryClient = useQueryClient();

  return useMutation<AdMutationResult, AxiosError, MutationParams>({
    mutationFn: async ({ adId, data }) => {
      const res = await axiosInstance.put<AdsApiResponse<AdMutationResult>>(
        '/v3-updateAd',
        { id: adId, ...data },
      );
      return res.data.data;
    },
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ADS_QUERY_KEY });
      options?.onSuccess?.(...args);
    },
  });
};
